import type { AiCreditsUsageParams } from "@circle-react/types/AiCreditsUsage";

import { buildPath } from "./buildPath";

export const credits = {
  balance: () => buildPath("/internal_api/credits/balance"),
  paymentIntents: {
    show: (id: string) =>
      buildPath(`/internal_api/credits/payment_intents/${id}`),
  },
  topUps: {
    create: () => buildPath("/internal_api/credits/top_ups"),
  },
  autoTopUpSetting: {
    update: () => buildPath("/internal_api/credits/auto_top_up_setting"),
    completePayment: () =>
      buildPath("/internal_api/credits/auto_top_up_setting/complete_payment"),
  },
  subscription: {
    upgrade: () => buildPath("/internal_api/credits/subscription/upgrade"),
    downgrade: () => buildPath("/internal_api/credits/subscription/downgrade"),
    cancel: () => buildPath("/internal_api/credits/subscription/cancel"),
  },
  aiCreditsConsumption: {
    show: (params: {
      start_date: string;
      end_date: string;
      filters?: { conversation_ids?: number[]; member_ids?: number[] };
    }) => buildPath("/internal_api/credits/ai_credits_consumption", params),
  },
  aiCreditsDailyConsumption: {
    show: (params: {
      start_date: string;
      end_date: string;
      filters?: { conversation_ids?: number[]; member_ids?: number[] };
    }) =>
      buildPath("/internal_api/credits/ai_credits_daily_consumption", params),
  },
  aiCreditsConversations: {
    index: (params: { start_date: string; end_date: string; page?: number }) =>
      buildPath("/internal_api/credits/ai_credits_conversations", params),
  },
  aiCreditsMembers: {
    index: (params: { start_date: string; end_date: string }) =>
      buildPath("/internal_api/credits/ai_credits_members", params),
  },
  aiCreditsProjects: {
    index: (params: { start_date: string; end_date: string }) =>
      buildPath("/internal_api/credits/ai_credits_projects", params),
  },
  aiCreditsUsageSummary: {
    show: (params: AiCreditsUsageParams) =>
      buildPath("/internal_api/credits/ai_credits_usage_summary", params),
  },
  aiCreditsActivity: {
    index: (params: AiCreditsUsageParams) =>
      buildPath("/internal_api/credits/ai_credits_activity", params),
  },
  aiCreditsUsageOptions: {
    titles: (params: AiCreditsUsageParams) =>
      buildPath(
        "/internal_api/credits/ai_credits_usage_options/titles",
        params,
      ),
    usedBy: (params: AiCreditsUsageParams) =>
      buildPath(
        "/internal_api/credits/ai_credits_usage_options/used_by",
        params,
      ),
  },
  cycles: {
    index: (params?: { page?: number; per_page?: number }) =>
      buildPath("/internal_api/credits/cycles", params),
  },
};
